<template>
  <div class="ChanpinManagement">
    <div>
      <el-form ref="form" label-width="80px">
        <el-row style="margin-top: 20px">
          <el-col :span="4">
            <el-form-item label="类型">
              <el-select
                v-model="form.order_type"
                placeholder="请选择"
                clearable
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="日期">
              <el-date-picker
                @change="tiemChange"
                v-model="tiem"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="timestamp"
                format="yyyy-MM-dd HH:mm"
              >
              </el-date-picker>

              <!-- <el-date-picker
			
              v-model="tiem"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
			  value-format="timestamp"
			  format="yyyy-MM-dd HH:mm"
            >
            </el-date-picker> -->
            </el-form-item>
          </el-col>
          <el-col :span="2" :offset="6">
            <el-button type="success" @click="seetabke">查询</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="margin-top: 30px">
      <el-table
        :data="tableData"
        border
        style="width: 90%; margin: 0 auto"
        max-height="730"
      >
        <!-- <el-table-column type="selection" align='center'>
					</el-table-column> -->
        <el-table-column prop="id" label="订单ID" align="center">
        </el-table-column>
        <el-table-column
          prop="organization_name"
          label="机构名称"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="course" label="已开通课程" align="center">
        </el-table-column>
        <el-table-column prop="order_type" label="类型" align="center">
        </el-table-column>
        <el-table-column prop="order_state" label="订单状态" align="center">
        </el-table-column>
        <el-table-column prop="remark" label="备注" align="center">
        </el-table-column>
        <el-table-column prop="start_time" label="开始时间" align="center">
        </el-table-column>
        <el-table-column prop="end_time" label="结束时间" align="center">
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间" align="center">
        </el-table-column>

        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-row>
              <el-col>
                <!-- scope.row -->
                <!-- {{scope.row}} -->
                <el-button
                  plain
                  type="success"
                  size="mini"
                  @click="see(scope.row)"
                  >查看</el-button
                >
              </el-col>
            </el-row>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="prev, pager, next, jumper"
        @current-change="handleCurrentChange"
        :page-size="pagesize"
        :total="allpage"
        style="margin-left: calc(40%); margin-top: 20px"
        v-if="allpage >= 9"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { TrainorderList } from "../assets/js/network/network.js";
import UtilityTime from "@/assets/js/utility/UtilityTime";
export default {
  components: {},
  data() {
    return {
      options: [
        { label: "试用", value: 0 },
        { label: "正式", value: 1 },
      ],
      tiem: "",
      form: {
        order_type: "",
        start_time: "",
        end_time: "",
      },
      tableData: [],
      pagesize: "",
      allpage: "",
      current_page: "",
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      TrainorderList(this.form, this.current_page).then((res) => {
        if (res.code == 0) {
          this.tableData = res.ret.data;
          this.tableData.map((item) => {
            item.order_state = item.order_state == 0 ? "废弃" : "正常";
            item.create_time = UtilityTime.retun_formatDate11(item.create_time);
            item.start_time = UtilityTime.retun_formatDate11(item.start_time);
            item.end_time = UtilityTime.retun_formatDate11(item.end_time);
            item.order_type = item.order_type == 0 ? "试用订单" : "正式订单";
          });
          this.pagesize = res.ret.per_page;
          this.allpage = res.ret.total;
          this.current_page = res.ret.current_page;
        }
      });
    },
    handleCurrentChange(val) {
      this.current_page = val;
      this.getList();
    },
    seetabke() {
      this.getList();
    },
    tiemChange(v) {
      console.log(v);
      if (v) {
        this.form.start_time = v[0] / 1000;
        this.form.end_time = v[1] / 1000;
      } else {
        this.form.start_time = "";
        this.form.end_time = "";
      }
    },
  },
};
</script>
<style scoped>
@import "../style/common.css";
</style>
